module.exports = __webpack_public_path__ + "static/media/SimHei.84c87551.svg";